export default {
  'STOCK': 'Securities',
  'FUTURES': 'Futures',
  'FOREX': 'Foreign Exchange',
  'IB': 'EddidPro',
  'PM': 'Spot Gold',
  'FUND': 'Fund',
  'SECURITIES_CASH': 'Securities (Cash) Account',
  'SECURITIES_MARGIN': 'Securities (Margin) Account',
  'FUTURES_MARGIN': 'Futures Account',
  'MT5': 'Foreign Exchange Account',
  'MF': 'Foreign Exchange Account (Eddid FX Pro)',
  'BULLION_MARGIN': 'Spot Gold Account',
  'INTERACTIVE_BROKER_INTEGRATED_MARGIN': 'EddidPro Account',
  'default': 'Account',
  'SECURITIES_AYERS_CASH': 'Discretionary Securities (Cash) Account',
  'FUTURES_DAYTRADING_MARGIN': 'Intra-Futures Day Trading Account',
  'FUND_CASH': 'Fund Account'
}
